export default __webpack_public_path__ + "static/media/AdobeStock_127055083.4a740c79.jpg";